import { useState, useCallback, useRef } from "react";

import { useAppI18n } from "./useAppI18n";

/**
 * Reusable hook for showing a toast when uploaded files exceed 10 MB.
 * Returns { toastMessage, showFileTooLarge, dismissToast }.
 */
export const useFileSizeToast = () => {
  const { t } = useAppI18n();
  const [toastMessage, setToastMessage] = useState<string | null>(null);
  const timerRef = useRef<number>(0);

  const dismissToast = useCallback(() => setToastMessage(null), []);

  const showFileTooLarge = useCallback(
    (filenames: string[]) => {
      clearTimeout(timerRef.current);
      const msg =
        filenames.length === 1
          ? t("conversation.fileTooLarge", { name: filenames[0] })
          : t("conversation.fileTooLargeMulti", {
              count: filenames.length,
            });
      setToastMessage(msg);
      timerRef.current = window.setTimeout(() => setToastMessage(null), 5000);
    },
    [t],
  );

  return { toastMessage, showFileTooLarge, dismissToast };
};
